<template>
    <CSpinner component="span" size="sm" aria-hidden="true"/> Cargando...
</template>

<script>
export default {
    name: "LoadingButton",
}
</script>